import PropTypes from "prop-types"
import { chain } from "lodash"
import AISummaryWithTabs from "./components/with-tabs"
import AISummaryWithoutTabs from "./components/without-tabs"

import "./styles.scss"

export function copySummary(summary, resourceName, addNotification) {
  const flattenedSummary = chain(summary).values().join("").value()
  navigator.clipboard.writeText(flattenedSummary)
  addNotification("success", null, `${resourceName} summary copied to clipboard.`)
}

export default function AISummaryWrapper(props) {
  const { isDashboard } = props
  return isDashboard ? <AISummaryWithTabs {...props} /> : <AISummaryWithoutTabs {...props} />
}

AISummaryWrapper.propTypes = {
  isDashboard: PropTypes.bool,
}
